export default " attribute vec4 a_position;\n void main() {\n     gl_Position = a_position;\n }"